webpackJsonp([209208286560102],{

/***/ 1310:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"A Student Perspective on Code Fellows' First Bootcamp","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/a-student-perspective-on-code-fellows-first-bootcamp","createdAt":"2013-11-08T04:08:49.148Z","blogAuthor":{"fields":{"name":"Alpha Ng","slug":"blog/author/alpha-ng"}},"imageHeader":null}}]},"authorJson":{"name":"Alpha Ng","slug":"blog/author/alpha-ng","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/alpha-ng"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-alpha-ng-b0a415d2e7d472da58db.js